import { render } from "./CertLawContainer.vue?vue&type=template&id=03faf18e"
import script from "./CertLawContainer.vue?vue&type=script&lang=js"
export * from "./CertLawContainer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\cert-v3\\cert\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__